// Network-transition store — tracks the brief "switching networks…"
// state that drives the global overlay. Cleared automatically after a
// minimum display window so the user always gets visual feedback even
// when the underlying switch is near-instant.

'use client';

import type { StoreApi, UseBoundStore } from 'zustand';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

import type { Network } from '@/lib/network';

export interface NetworkTransitionState {
  from: Network | null;
  to: Network | null;
  beginTransition: (from: Network, to: Network) => void;
  endTransition: () => void;
}

export const useNetworkTransitionStore: UseBoundStore<StoreApi<NetworkTransitionState>> =
  createTrackedStore<NetworkTransitionState>('useNetworkTransitionStore')(
    (set): NetworkTransitionState => ({
      from: null,
      to: null,
      beginTransition: (from: Network, to: Network): void => {
        set({ from, to });
      },
      endTransition: (): void => {
        set({ from: null, to: null });
      },
    }),
  );
